// BEAM design tokens — color. v1 "Blueprint".
// Single source of truth for color. Do NOT hardcode hex anywhere else in the app;
// import from here (or from `src/theme`).

export const palette = {
  indigo: '#1B2A6B',     // brand · primary action
  blueprint: '#2D4FB3',  // links · info
  copper: '#C26B3C',     // accent — sparing, brand-only (NEVER a status, NEVER body text)
  ink: '#1B2347',        // body text
  muted: '#6B6F86',      // secondary text
  paper: '#FCFBF8',      // app background
  surface: '#FFFFFF',    // cards / sheets
  grid: '#F4F5FB',       // subtle fills
  line: '#E4E1D7',       // borders / hairlines
  btnLine: '#D6D2C6',    // input + secondary-button borders
  copperWash: '#F7ECE5', // copper @ low alpha surrogate
  indigoWash: '#E7EAF6', // focus ring · ghost-button press · "sent" badge bg
  white: '#FFFFFF',
} as const;

// Status colors are shared app-wide so "paid" / "overdue" stay learnable.
// Each is an { fg, bg } pair for a badge or pill. Copper is intentionally absent here.
export const status = {
  draft:      { fg: '#475569', bg: '#EEF1F5' },
  sent:       { fg: '#2D4FB3', bg: '#E7EAF6' }, // also: info
  paid:       { fg: '#067A4E', bg: '#E7F6EE' }, // also: done / success
  overdue:    { fg: '#B42318', bg: '#FDECEB' }, // also: error / destructive text
  inProgress: { fg: '#9A6700', bg: '#FDF3DA' }, // also: warning / pending
} as const;

// Semantic roles — prefer these in components over raw palette names.
export const color = {
  bg:     { app: palette.paper, surface: palette.surface, subtle: palette.grid },
  text:   { primary: palette.ink, secondary: palette.muted, link: palette.indigo,
            onPrimary: palette.white, onAccent: palette.white },
  border: { default: palette.line, strong: palette.btnLine },
  action: { primary: palette.indigo, accent: palette.copper, danger: status.overdue.fg },
  focusRing: palette.indigoWash,
  // WO-H1 — modal/sheet dim overlay (palette.ink @ 35%). Single source for scrims.
  scrim: 'rgba(27,35,71,0.35)',
} as const;

export type StatusKey = keyof typeof status;
